import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type FeedbacksSettingsResponse as SchemaFeedbacksSettingsResponse } from '../schemas/FeedbacksSettingsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetIntegrationFeedbacksSettingsContentType = '' as const;
export type GetIntegrationFeedbacksSettingsRequest = void;
export type GetIntegrationFeedbacksSettingsResponses = LinkCommonErrorResponses & {
    /**
     * @description Feedbacks settings per integration system
     */
    '200': {
        'application/json': SchemaFeedbacksSettingsResponse;
    };
};
export type GetIntegrationFeedbacksSettingsResponseSuccess =
    GetIntegrationFeedbacksSettingsResponses['200']['application/json'];
export type GetIntegrationFeedbacksSettingsSearchParams = undefined;
export type GetIntegrationFeedbacksSettingsPathParameters = undefined;
export const GetIntegrationFeedbacksSettingsUrl = '/integrations/settings/feedbacks' as const;
export const GetIntegrationFeedbacksSettingsMethod = 'GET' as const;
export const getGetIntegrationFeedbacksSettingsUrl = (_params?: GetIntegrationFeedbacksSettingsPathParameters) =>
    GetIntegrationFeedbacksSettingsUrl;
